import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {

    transform(formatName: string): string {
        if (!formatName) return '';

        const nameParts = formatName.split(' ');

        // Capitalize the first letter of the first two words
        const capitalizedParts = nameParts.map((part, index) => {
            if (index < 2) {
                return part.charAt(0).toUpperCase() + part.slice(1);
            }
            return part;
        });

        // Combine the initials of the first two words
        const initials = capitalizedParts.slice(0, 2).map(part => part.charAt(0)).join('').toUpperCase();

        return initials;
    }

}
